import { render, staticRenderFns } from "./ElectronicBilling.vue?vue&type=template&id=5deb1cb8&scoped=true&"
import script from "./ElectronicBilling.vue?vue&type=script&lang=js&"
export * from "./ElectronicBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deb1cb8",
  null
  
)

export default component.exports